import { PRODUCT_TYPE_ID } from '../constants/catalog';

export const hasOfficeHoursTitleAddOns = (titleAddOn: string | undefined | null) => {
  return titleAddOn?.toLowerCase().includes(CHARACTERISTIC_VALUES.TITLE_ADDONS);
};

enum CHARACTERISTIC_VALUES {
  USAGE_METER_UNLIMITED = 'unlimited',
  FAMILY_UNLEASHED = 'unleashed',
  TITLE_ADDONS = 'plus unlimited office hours data',
}

export const hasUnlimitedUsageMeter = (usageMeter: string): boolean =>
  Boolean(usageMeter?.toLowerCase().includes(CHARACTERISTIC_VALUES.USAGE_METER_UNLIMITED));

export const isUnleashedFamily = (family: string, planName: string): boolean =>
  // Returns true for Unleashed and Unleashed Max plans
  Boolean(family.toLowerCase().includes(CHARACTERISTIC_VALUES.FAMILY_UNLEASHED)) &&
  planName.toLowerCase().includes(CHARACTERISTIC_VALUES.FAMILY_UNLEASHED);

export const isUnleashedMaxPlan = (productTypeId: string): boolean => productTypeId === PRODUCT_TYPE_ID.UNLEASHED_MAX;

export const showTitleAddons = (family: string, planName: string, titleAddOns?: string | null) => {
  const hasUnleashedFamily = isUnleashedFamily(family, planName);
  const showTitleAddons = hasUnleashedFamily ? false : Boolean(titleAddOns);

  return showTitleAddons;
};

export const isVoiceOnlyPlan = (productTypeId: string) =>
  [PRODUCT_TYPE_ID.VOICE_ONLY_RES, PRODUCT_TYPE_ID.VOICE_ONLY_SMB].includes(productTypeId);
